import { useMutation } from "@apollo/client";
import { constantsData, statusTypesData } from "data";
import { createClientFoldersStructureFilesMutation, getClientQuery } from "graph";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useCreateClientFoldersStructureFiles = (clientId) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [createClientFoldersStructureFilesAction, { loading }] = useMutation(
        createClientFoldersStructureFilesMutation,
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: getClientQuery,
                    variables: {
                        where: { id: clientId },
                    },
                },
            ],
        },
    );

    const createClientFoldersStructureFiles = async ({
        files,
        parentPath,
    }) => {
        try {
            await createClientFoldersStructureFilesAction({
                onCompleted: () => {
                    dispatch(openAlert(
                        t(
                            "messages.saveMsgs.success",
                            { entity: t("labels.files") },
                        ),
                        statusTypesData.success,
                    ));
                },

                variables: {
                    clientId,
                    files,
                    parentPath,
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        createClientFoldersStructureFiles,
        loading,
    };
};

export default useCreateClientFoldersStructureFiles;
